import { Component } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MatExpansionModule } from '@angular/material/expansion'
import { MatIconModule } from '@angular/material/icon'
import { MatTooltipModule } from '@angular/material/tooltip'
import { APP_NAME } from '@core/constants/constant.data'
import { STANDALONE_CMS } from './stand-alone-cms.data'

@Component({
  selector: 'app-stand-alone-cms',
  templateUrl: './stand-alone-cms.component.html',
  styleUrls: ['./stand-alone-cms.component.scss'],
  imports: [
    // Material
    MatTooltipModule,
    MatExpansionModule,
    MatButtonModule,
    MatIconModule,
  ],
})
export class StandAloneCMsComponent {
  standaloneCMs = STANDALONE_CMS.filter((cms) => cms.project.includes(APP_NAME))
}
